import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { MenuItem } from 'react-bootstrap/lib';
import withDealerPermission from './dealerPermission';

function RunAutomationButton({ dealer, runAutomation, type }) {
  if (!dealer) {
    return null;
  }
  if (type === 'online') {
    return (
      <MenuItem onClick={() => runAutomation(dealer, 'online')}>
        Run Automation Online
      </MenuItem>
    );
  }
  return (
    <MenuItem onClick={() => runAutomation(dealer)}>
      Run Automation Tests
    </MenuItem>
  );
}

RunAutomationButton.propTypes = {
  dealer: PropTypes.object,
  runAutomation: PropTypes.func,
  type: 'string',
};

export default withDealerPermission(Permissions.CREATE)(RunAutomationButton);
